import { useMemo } from 'react'
import { SelectBox, type SelectBoxProps } from './SelectBox'

export type TimezoneBoxProps =
  Omit<SelectBoxProps<string>, 'options' | 'valueToString' | 'valueFromString'>

export function TimezoneBox(props: TimezoneBoxProps) {
  const timezones = useMemo(() => getAllTimeZones(), [])

  return (
    <SelectBox<string>
      {...props}
      options={[
        { label: 'Etc/UTC', value: 'UTC' },
        '-----',
        { label: 'America/New_York', value: 'America/New_York' },
        { label: 'America/Chicago', value: 'America/Chicago' },
        { label: 'America/Denver', value: 'America/Denver' },
        { label: 'America/Los_Angeles', value: 'America/Los_Angeles' },
        { label: 'America/Phoenix', value: 'America/Phoenix' },
        { label: 'America/Anchorage', value: 'America/Anchorage' },
        { label: 'America/Adak', value: 'America/Adak' },
        { label: 'Pacific/Honolulu', value: 'Pacific/Honolulu' },
        '-----',
        ...timezones.map(zone => ({
          label: zone,
          value: zone,
        }))
      ]}
    />
  )
}


//--------------------------------------------------------------------------------
function getAllTimeZones(): string[] {
  // Prefer the runtime's full list of IANA time zones when available
  const intlAny = typeof Intl !== 'undefined' ? (Intl as any) : undefined
  if (intlAny?.supportedValuesOf) {
    try {
      // IANA time zones
      const zones = intlAny.supportedValuesOf('timeZone') as string[]
      if (Array.isArray(zones) && zones.length > 0) {
        return [...zones].sort()
      }
    } catch {
      // fall through to static fallback
    }
  }

  // Fallback list (common zones) if supportedValuesOf is not available
  const fallback = [
    'UTC',
    'Etc/UTC',
    'Etc/GMT',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Phoenix',
    'America/Anchorage',
    'Pacific/Honolulu',
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    'Europe/Madrid',
    'Europe/Rome',
    'Europe/Amsterdam',
    'Europe/Prague',
    'Europe/Warsaw',
    'Europe/Moscow',
    'Asia/Jerusalem',
    'Asia/Dubai',
    'Asia/Kolkata',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Tokyo',
    'Asia/Seoul',
    'Australia/Sydney',
    'Australia/Melbourne',
    'Pacific/Auckland',
  ]

  return fallback
}
